<template>
  <a-row class="main">
    <a-col :span="6" class="cover" v-if="currentIndex != 3">
      <img :src="item.img_url" @click="toPage(item)" />
    </a-col>
    <a-col :span="4" :class="currentIndex != 3 ? 'headline': 'headlines'" @click="toPage(item)">
      <span>{{item.course_name || item.course_title || item.title}}</span>
      <span v-if="currentIndex == 4">{{item.brief}}</span>
      <span v-if="currentIndex == 2"><img src="@img/eye.png" alt>{{item.viewer_num}}</span>
    </a-col>
    <a-col :span="5" class="create-time">
      <span v-if="currentIndex == 0 || currentIndex == 2">{{item.create_time| dateformat('YYYY-MM-DD HH:mm:ss')}}</span>
      <span v-if="currentIndex == 3">{{ item.add_time | dateformat('YYYY-MM-DD HH:mm:ss')}}</span>
    </a-col>
    <a-col :span="4" v-if="currentIndex != 4" :class="item.prime_price == 0 ? 'free':'price'">{{item.on_public == 1 ? '免费':priceshow == true ? `¥${item.real_price / 100}` : ''}}</a-col>
    <a-col :span="currentIndex != 4 ? 4 : 8" class="btn">
      <span v-if="currentIndex == 0" @click="toCourse(item.id,item.course_type)">立即学习</span>
      <span v-if="currentIndex == 2" class="cancel" @click="cancelFollow(item.id)">取消收藏</span>
      <span v-if="currentIndex == 3" @click="toCourse(item.course_id,item.course_type)">继续学习</span>
      <span v-if="currentIndex == 4" class="cancel" @click="unFollow(item.id)">取消关注</span>
    </a-col>
  </a-row>
</template>
<script>
import { group_sign,getCookie } from '../../../utils/tool';
import { mapState, mapMutations } from "vuex";
export default {
  name: "infoDes",
  components: {},
  props: ["item", "currentIndex"],
  data() {
    return {
      img_url: require("@img/default_cover.png"),
      account_id:Number(getCookie('account_id')),
      student_id: Number(getCookie('studentId')),
    };
  },
  computed: {
    ...mapState(["priceshow"]),
  },
  methods: {
    toCourse(id, type) {
      this.$router.push({
        path: "/page/course_details",
        query: { course_id: id, course_type: 0 }
      });
    },
    toPage(item) {
      if (this.currentIndex == 2) {
        this.toCourse(item.id, 0);
      } else if (this.currentIndex == 4) {
        this.$router.push({
          path: "/page/teacher_details",
          query: { id: item.id }
        });
      }
    },
    cancelFollow(id) {
      var param = group_sign({account_id: this.account_id,student_id: this.student_id,video_course_id: id,collect_state:0})
        this.$axios.post(this.$Api.apiGetCourseCollect, param).then(
          res => {
            this.$parent.showMyData(2);
          }
        ).catch(error => {console.log(error, ">>>>>>>>>");})
    },
    unFollow(id) {
      var param = group_sign({account_id: this.account_id,student_id: this.student_id,teacher_id: id,collect_state: 0})
        this.$axios.post(this.$Api.apiGetCollectTeacher, param).then(
          res => {
            this.$parent.showMyData(4);
          }
        ).catch(error => {console.log(error, ">>>>>>>>>");})
    }
  }
};
</script>
<style lang="less" scoped>
.main {
  padding: 20px 0;
  border-top: 1px solid #e6e6e6;
  .cover {
    padding-left: 15px;
    img {
      width: 185px;
      height: 115px;
    }
  }
  .headline {
    cursor: pointer;
    font-size: 14px;
    color: #333;
    span {
      display: block;
      line-height: 55px;
      overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
      img {
        width: 20px;
        height: 20px;
      }
    }
  }
  .headlines {
        width: 331px;
    margin: 10px;
    span {
          display: block;
    word-break: break-all;
    height: 30px;
    line-height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    }
  }
  .create-time {
    display: flex;
    flex-direction: column;
    color: #999;
    span {
      margin-top: 15px;
    }
  }
  .free {
    padding-top: 15px;
    color: #0a9a3d;
  }
  .price {
    padding-top: 15px;
    color: #f5a623;
  }
  .btn {
    display: flex;
    justify-content: flex-end;
    padding-right: 15px;
    span {
      cursor: pointer;
      margin-top: 10px;
      width: 80px;
      height: 32px;
      background: #3b9dff;
      text-align: center;
      color: #fff;
      display: block;
      line-height: 32px;
      border-radius: 4px;
      border: 1px solid #ebebeb;
      transition: 0.3s ease all;
      &:hover {
        transform: translateY(-6px);
        -webkit-transform: translateY(-6px);
        -moz-transform: translateY(-6px);
        box-shadow: 0 26px 40px -24px rgba(0, 36, 100, 0.3);
        -webkit-box-shadow: 0 26px 40px -24px rgba(0, 36, 100, 0.3);
        -moz-box-shadow: 0 26px 40px -24px rgba(0, 36, 100, 0.3);
      }
    }
    .cancel {
      border: 1px solid #cccccc;
      background: #fff;
      color: #ccc;
    }
  }
}
</style>
